(function () {
  var KEY = 'mcw-popup';
  var read = function () { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } };
  var save = function (value) { try { localStorage.setItem(KEY, JSON.stringify(Object.assign(read(), value))); } catch (e) {} };

  function init() {
    var dialog = document.getElementById('WelcomePopup');
    var overlay = document.getElementById('WelcomePopupOverlay');
    var float = document.getElementById('WelcomePopupFloat');
    var body = dialog && dialog.querySelector('.mcw__body');
    var success = document.getElementById('WelcomePopupSuccess');
    if (!dialog || !dialog.show || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    var designMode = window.Shopify && Shopify.designMode;
    var section = dialog.closest('[id^="shopify-section-"]');
    var serverState = dialog.querySelector('[data-state]');

    var syncFloat = function () {
      var seen = read();
      var usable = designMode || !seen.used;
      float.hidden = dialog.open || !usable || !dialog.dataset.float;
      float.querySelector('[data-float-label]').textContent = seen.registered ? float.dataset.labelCode : float.dataset.labelOffer;
    };
    var open = function () {
      if (dialog.open) return;
      // Quien ya se registró vuelve a ver su código, no el formulario.
      if (read().registered && !dialog.querySelector('[data-code]')) body.innerHTML = success.innerHTML;
      dialog.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
      overlay.hidden = false;
      document.documentElement.classList.add('mcw-lock');
      dialog.show();
      dialog.querySelector('[data-close]').focus({ preventScroll: true });
      syncFloat();
    };
    var hide = function () {
      if (dialog.open) dialog.close();
      overlay.hidden = true;
      document.documentElement.classList.remove('mcw-lock');
      syncFloat();
    };
    var dismiss = function () {
      save({ until: Date.now() + Number(dialog.dataset.days || 7) * 864e5 });
      hide();
    };

    // Cumpleaños como etiquetas: permite crear segmentos por mes o por fecha.
    var birthday = dialog.querySelector('[data-birthday]');
    var tags = dialog.querySelector('[data-tags]');
    if (birthday && tags) {
      var baseTags = tags.value;
      var syncTags = function () {
        var parts = birthday.value.split('-');
        tags.value = parts.length === 3
          ? baseTags + ', cumple-' + birthday.value + ', cumple-mes-' + parts[1]
          : baseTags;
      };
      birthday.addEventListener('input', syncTags);
      birthday.addEventListener('change', syncTags);
    }

    overlay.addEventListener('click', dismiss);
    float.addEventListener('click', open);
    dialog.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { dismiss(); return; }
      if (e.target.closest('[data-done]')) { save({ used: true }); return; }
      var copy = e.target.closest('[data-copy]');
      if (copy && navigator.clipboard) {
        navigator.clipboard.writeText(dialog.querySelector('[data-code]').textContent).then(function () { copy.textContent = 'Copiado'; });
      }
    });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { dismiss(); return; }
      if (e.key !== 'Tab') return;
      var items = [].slice.call(dialog.querySelectorAll('a[href], button, input:not([type="hidden"])'));
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // Personalizador: se abre al seleccionar la sección y sigue abierto mientras editas.
    if (designMode) {
      window.__mcwOpen = open;
      window.__mcwHide = hide;
      window.__mcwSection = section && section.id;
      if (window.__mcwEditing) open(); else syncFloat();
      return;
    }

    if (serverState) {
      if (serverState.dataset.state === 'success') save({ registered: true });
      open();
      return;
    }
    var seen = read();
    syncFloat();
    if (seen.used || seen.registered || (seen.until && seen.until > Date.now())) return;
    setTimeout(open, Number(dialog.dataset.delay || 0) * 1000);
  }

  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.id !== window.__mcwSection) return;
    window.__mcwEditing = true;
    if (window.__mcwOpen) window.__mcwOpen();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target.id !== window.__mcwSection) return;
    window.__mcwEditing = false;
    if (window.__mcwHide) window.__mcwHide();
  });
})();